<template>
  <b-form-group label="Vacina" label-for="vaccine-input" label-class="font_size_label">
    <v-select 
    id="vaccine-input"
    v-model="search.vacina"
    variant="custom"
    class="bg-white"
    label="nome_tecnico"
    :options="vaccineSelect"
    placeholder="Selecione uma vacina"
    @input="$emit('input', $event)"
    :loading="loadingData"
    :disabled="loadingData"
    >
      <span slot="no-options">Nenhuma opção selecionável.</span>
    </v-select>
  </b-form-group>
</template>

<script>
import {
  BFormGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    vSelect
  },
  props: {
    search: {
      type: Object,
      default: () => ({
        vaccine: null
      })
    },
    idEmpresa: {
      type: Number,
      required: false
    },
    idGrupo: {
      type: Number,
      required: false
    },
    idCampanha: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      vaccineSelect: [],
      loadingData: false
    }
  },
  mounted() {
    this.loadVaccineSelect();  
  },
  methods: {
    async loadVaccineSelect() {
      this.loadingData = true
      try {
        const response = await this.$http.get(this.$api.vacinaCampanhaId(this.idCampanha), {
          params: {
            id_empresa: this.idEmpresa,
            id_grupo: this.idGrupo
          }
        });
        
        this.vaccineSelect = response.data;
        this.loadingData = false

      } catch (error) {
        console.error("Erro ao carregar vacinas:", error);
        this.doseSelect = [];
      }
    },
  }
}
</script>

<style scoped>
.font_size_label {
  font-size: 0.8rem;
}
</style>

